import type { Locale } from '@/content'

export const STORAGE_KEY = 'kima-language'

export function detectLocale(storage: Storage | undefined, language = ''): Locale {
  try {
    const saved = storage?.getItem(STORAGE_KEY)
    if (saved === 'el' || saved === 'en') return saved
  } catch { /* private browsing */ }
  return language.toLowerCase().startsWith('en') ? 'en' : 'el'
}

export function saveLocale(storage: Storage | undefined, locale: Locale) {
  try { storage?.setItem(STORAGE_KEY, locale) } catch { /* private browsing */ }
}
